<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/16/solid';
import { computed } from 'vue';

const model = defineModel<any>()
const { value } = defineProps<{ value: any }>()
const emit = defineEmits<{ input: [value: any] }>()

const isSelected = computed(() => {
    if (Array.isArray(model.value)) {
        return model.value.some(item => JSON.stringify(item) === JSON.stringify(value))
    }

    return JSON.stringify(model.value) === JSON.stringify(value)
})

function handleInput() {
    const handleUpdateData = () => {
        const modelUpdate = JSON.parse(JSON.stringify(model.value))

        if (Array.isArray(modelUpdate)) {
            const currentIndex = modelUpdate.findIndex(modelValue => JSON.stringify(modelValue) === JSON.stringify(value))
            if (currentIndex >= 0) {
                modelUpdate.splice(currentIndex, 1)
                return modelUpdate
            }

            modelUpdate.push(value)
            return modelUpdate
        }

        if (JSON.stringify(modelUpdate) === JSON.stringify(value)) {
            return null
        }

        return value
    }
    const modelUpdate = handleUpdateData()
    model.value = modelUpdate
    emit('input', value)
}
</script>

<template>
    <label class="size-6 border-2 border-blue-600 cursor-pointer rounded flex items-center justify-center"
        :class="{
            'bg-blue-600': isSelected
        }">
        <input @input="handleInput" type="checkbox" class="hidden" />
        <CheckIcon v-if="isSelected" class="size-5 fill-white" />
    </label>
</template>